<template>
  <div>
    <el-row>
      <el-col>
        <el-button style="margin-top:18px" size="medium" @click="addProduct">新增产品</el-button>
        <el-tooltip class="item" effect="dark" content="进入临时仓" placement="top-start">
          <el-button size="medium" @click="showImport">导入库存</el-button>
        </el-tooltip>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="product_table" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="50"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" min-width="30"></el-table-column>
          <el-table-column label="单价" prop="PRODUCT_PRICE" width="100">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.PRODUCT_PRICE" @blur="saveProperty()" placeholder="单价" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="订购数量" prop="PRODUCT_COUNT" width="100">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.PRODUCT_COUNT" @blur="saveProperty()" placeholder="数量" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="生产日期" width="140">
            <template slot-scope="scope">
              <el-date-picker style="width:130px" v-model="scope.row.PRODUCTION_DATE" type="date" @blur="saveProperty()" placeholder="生产日期"
                value-format="yyyy-MM-dd" :clearable="true" size="small"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="保质期" min-width="70">
            <!-- <template slot-scope="scope">
                            <el-input size="small" v-model="scope.row.EXPIRATION_DAY" @blur="saveProperty()" placeholder="保质天数" clearable></el-input>
                        </template> -->
            <template slot-scope="scope">
              <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="COMMENT" width="150">
            <template slot-scope="scope">
              <el-input autosize type="textarea" size="small" v-model="scope.row.COMMENT" @blur="saveProperty()" placeholder="备注"
                clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="deleteProduct(scope.row, scope.index)" icon="el-icon-close"
                style="color:#F56C6C">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="small" @click="submit" style="float:right;margin-top: 20px">全部确认</el-button>
      </el-col>
    </el-row>
    <el-dialog title="新增产品" center :visible.sync="addFormVisible" width="70%" :close-on-click-modal="false">
      <el-form size="small" :inline="true" class="demo-form-inline" :model="searchForm" ref="searchForm" @submit.native.prevent>
        <el-form-item label="产品编码：">
          <el-input placeholder="产品编码" @keyup.enter.native="seachFun()" clearable v-model="searchForm.code" :value="searchForm.code"></el-input>
        </el-form-item>
        <el-form-item label="产品名称：">
          <el-input placeholder="产品名称" @keyup.enter.native="seachFun()" clearable v-model="searchForm.name" :value="searchForm.name"></el-input>
        </el-form-item>
        <el-button size="small" @click="queryTable()">搜索</el-button>
      </el-form>
      <el-row>
        <el-col :span="24">
          <el-table stripe border :data="mainList" style="width: 100%" max-height="350">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <!-- <el-table-column label="图片" prop="PIC_URL"  min-width="45">
                        <template slot-scope="scope">
                            <img :src="showImg(scope.row)" style="width: 80px; height: 80px" onerror="this.src='https://service.linkda.com.cn/productImg.jpg';this.onerror=null"/>
                        </template>
                        </el-table-column> -->
            <el-table-column label="编码" prop="PRODUCT_CODE" width="120"></el-table-column>
            <el-table-column label="名称" prop="NAME" min-width="100"></el-table-column>
            <el-table-column label="单位" prop="TYPE_UNIT" width="50"></el-table-column>
            <el-table-column label="单价" prop="PRICE" width="130">
              <template slot-scope="scope">
                <el-input v-model="scope.row.product_price" placeholder="输入价格" @keyup.enter.native="addShopCar(scope.row)" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column label="购买数量" prop="product_count" width="130">
              <template slot-scope="scope">
                <el-input v-model="scope.row.product_count" @keyup.enter.native="addShopCar(scope.row)" clearable>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button size="small" @click="addInstock(scope.row)">加入</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
            layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormVisible = false">取 消</el-button>
        <el-button size="small" @click="addFormVisible = false" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入入库" center :visible.sync="importVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="importForm" :model="importForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove" :name="this.importForm.file"
          multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downLoadResetTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeImport()">取 消</el-button>
        <el-button size="small" @click="submitImport('importForm')" :loading="loading2">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addInstockConfirm, manualImport } from '@/assets/api/warehouseManager';
import { queryUseSKU } from '@/assets/api/skuManage';
import { frontEndFun } from '@/assets/api/frontFun';
import date from '@/assets/common/date';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      PAGE_ID: '11201', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1120101: 0 }, // 功能ID 一旦规定不要轻易改动
      loading: false,
      loading1: false,
      loading2: false,
      orderCode: sessionStorage.getItem('orderCode'),
      tableData: [],
      editFormVisible: false,
      editForm: {},
      formLabelWidth: '120px',
      firstForm: {},
      addForm: {},
      PRODUCT_NAME: '',
      TYPE_UNIT: '',
      SUPPLIER_ID: '',
      topData: [],
      addFormVisible: false,
      searchForm: {},
      mainList: [],
      product_table: [],
      timer: null,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      currentPage: 1,
      url: '',
      fileList: [],
      importForm: {
        file: 'tmp',
      },
      importVisible: false,
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
    };
  },
  created() {
    this.queryBeforeFun();
    const list = JSON.parse(sessionStorage.getItem('manual_instock'));
    if (list) {
      this.product_table = list;
    }
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    addProduct() {
      this.addFormVisible = true;
    },
    // 拉取
    queryTable() {
      if (!validation.产品编码验证(this.searchForm.code)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        STATUS: 1, // 启用的 SKU 才能搜到
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.code) {
        params.PRODUCT_CODE = parseInt(this.searchForm.code);
      }
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      queryUseSKU(params).then((result) => {
        if (result[0] && result[0].list.length) {
          this.tableData = result[0].list;
          this.mainList = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
          this.mainList = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addInstock(row) {
      if (!validation.价格正数0验证(row.product_price)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return;
      }
      const product = {
        NAME: row.NAME,
        TYPE_UNIT: row.TYPE_UNIT,
        PRODUCT_CODE: row.PRODUCT_CODE,
        PRODUCT_COUNT: row.product_count,
        PRODUCT_PRICE: row.product_price,
        PRODUCTION_DATE: date(new Date(), '%F'),
        COMMENT: '',
        // EXPIRATION_DAY: 1,
        QGP: row.QGP,
        QGP_TIME_TYPE: row.QGP_TIME_TYPE,
        index: this.product_table.length,
      };
      this.product_table.push(product);
      sessionStorage.setItem('manual_instock', JSON.stringify(this.product_table));
    },
    deleteProduct(row) {
      this.product_table.forEach((item, index) => {
        if (item.index == row.index) {
          this.product_table.splice(index, 1);
        }
      });
      sessionStorage.setItem('manual_instock', JSON.stringify(this.product_table));
    },
    submit() {
      if (!this.product_table.every((item) => validation.价格正数0验证(item.PRODUCT_PRICE))) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return;
      }
      const arr = this.product_table.map((item) => ({
        ...item,
        PRODUCT_PRICE: item.TYPE_UNIT == '斤' ? item.PRODUCT_PRICE * 2 : item.PRODUCT_PRICE,
        PRODUCT_COUNT: item.TYPE_UNIT == '斤' ? item.PRODUCT_COUNT / 2 : item.PRODUCT_COUNT,
      }));
      const params = {
        PRODUCT_ARRAY: arr,
      };
      addInstockConfirm(params).then((result) => {
        this.$message.show({ text: '入库成功', type: 'success' });
        sessionStorage.removeItem('manual_instock');
        this.product_table.splice(0);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 防抖
    saveProperty() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        sessionStorage.setItem('manual_instock', JSON.stringify(this.product_table)).map((item) => { });
        this.timer = null;
      }, 500);
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    //   下载模板
    downLoadResetTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/pw2Manual_In_Warehouse.xls';
    },
    closeImport() {
      this.importVisible = false;
      this.fileList = [];
    },
    showImport() {
      this.importVisible = true;
    },
    submitImport() {
      const params = {
        FILE_NAME: this.url,
      };
      this.loading2 = true;
      manualImport(params)
        .then((result) => {
          if (result[0].FILE_PATH !== '') {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.$message.show({ text: '导入失败，失败原因查看下载文件', type: 'warning' });
          } else {
            this.$message.show({ text: '导入成功', type: 'success' });
          }
          this.importVisible = false;
          this.loading2 = false;
          document.body.style.cursor = 'default';
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.loading2 = false;
          this.importVisible = false;
          document.body.style.cursor = 'default';
        });
    },
  },
};
</script>
<style scope>
.inline-input {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/manualInstock.vue